import { GET_PUBLIC_HOLIDAYS, STOP_LOADING, HOLIDAY_ERROR, ACCESS_RIGHT_ERROR, EDIT_SYSTEM_SETTING, START_LOADING } from "../HolidayAction/types";


const INITIAL_STATE = {
  loading: false,
  success: false
}

export default function (state = INITIAL_STATE, action) {

  switch (action.type) {
    case GET_PUBLIC_HOLIDAYS:
      return {
        ...state,
        public_holidays: action.payload,
        loading: false,
        success: false
      }
    case START_LOADING:
      return {
        ...state,
        loading: true
      }
    case EDIT_SYSTEM_SETTING:
      return {
        ...state,
        edited_system_setting: action.payload,
        loading: false
      }
    case HOLIDAY_ERROR:
      return {
        ...state,
        error_message: action.payload,
        loading: false
      }
    case ACCESS_RIGHT_ERROR:
      return {
        ...state,
        access_error: action.payload,
        loading: false
      }
    case STOP_LOADING:
      return {
        ...state,
        loading: false
      }
    default:
      return {
        ...state
      }
  }
}